import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '@app/components/components.module';
import { PrFunnelPersonsComponent } from './pr-funnel-persons.component';

@NgModule({
  declarations: [PrFunnelPersonsComponent],
  imports: [CommonModule, ReactiveFormsModule, ComponentsModule],
  exports: [PrFunnelPersonsComponent],
})
export class PrFunnelPersonsModule {}
